/*************************************************/
/* 3rd Party                                     */
/*************************************************/

// Passive event listeners
document.addEventListener('touchstart', () => { }, { passive: true });
document.addEventListener('touchmove', () => { }, { passive: true });


/*************************************************/
/* Partials                                      */
/*************************************************/

import { intersectionObservation } from "./partials/intersectionObservation.js";
import { header } from "./partials/header.js";
import { language } from "./partials/language.js";
import { menu } from "./partials/menu.js";
import { search } from "./partials/search.js";
import { searchbar } from "./partials/searchbar.js";
import { accordion } from "./partials/accordion.js";
import { video } from "./partials/video.js";
import { modal } from "./partials/modal.js";
import { languageSwitchTrigger } from "./partials/languageSwitchTrigger.js";
import { cookies } from "./partials/cookies.js";
import { slider } from "./partials/slider.js";
import { accordionImages } from "./partials/accordion.js";
import { textCollapse } from "./partials/textCollapse.js";
import { mix } from "./partials/mixItUp.js";
import { downloads } from "./partials/downloads.js";
import { visitorLocationSiteSwitch } from "./partials/_visitor-location-site-switch.js";

/*************************************************/
/* Init                                          */
/*************************************************/

const ready = callback => {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
}

ready(() => {
    const body = document.querySelector('body');
    const bodyLoadingClass = 'is-loading';

    //Handle scroll to submitted form element
    const formSubmittedElement = document.getElementById("umbraco-forms-form-submitted--clienti");
    if (formSubmittedElement) {
        window.scrollTo(0, formSubmittedElement.closest('.form-item').offsetTop);
    }

    //Fire dataLayer event for forms submission
    const formSubmitMessage = document.querySelector('[class^="umbraco-forms-submitmessage"]');
    if (formSubmitMessage) {
        window.dataLayer.push({
            'event': 'formSubmission',
            'formType': formSubmitMessage.dataset.formName
        });
    }

    //Add click listener to skip link
    document.querySelector('#skipLink').addEventListener('click', e => {
        document.querySelector('#mainContent').focus();
    });

    intersectionObservation();
    header(body);
    language();
    menu();
    search();
    searchbar(body);
    accordion();
    modal(body, bodyLoadingClass);
    languageSwitchTrigger();
    video();
    cookies();
    slider();
    accordionImages();
    textCollapse();
    mix();
    visitorLocationSiteSwitch();
    downloads();
});
